import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HandHeart, X } from "@/lib/icons";
import { toast } from "sonner";

const REPLIES = [["thanks", "Thanks 🌱"], ["okay", "Doing okay"], ["hard_week", "Having a hard week"]];

function ReplyRow({ nudge, onDone }) {
  const [pick, setPick] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await api.post(`/nudges/${nudge.id}/reply`, { reply: pick, note });
      toast.success(pick === "hard_week" ? `${nudge.from_name} will see that this week is hard. No check-in needed.` : `Sent "${REPLIES.find((r) => r[0] === pick)[1]}" to ${nudge.from_name}.`);
      onDone();
    } catch { toast.error("Couldn't send your reply right now."); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3" data-testid={`nudge-reply-${nudge.id}`}>
      <div className="flex flex-wrap gap-1.5">
        {REPLIES.map(([k, label]) => (
          <button key={k} onClick={() => setPick(k)} data-testid={`nudge-reply-${k}`} aria-pressed={pick === k}
            className={`text-xs font-semibold px-3 py-1.5 rounded-full border transition-colors ${pick === k ? "bg-stone-900 text-white border-stone-900" : "bg-white text-stone-700 border-stone-300 hover:border-amber-600"}`}>{label}</button>
        ))}
      </div>
      {pick && (
        <div className="flex gap-2 mt-2">
          <input value={note} onChange={(e) => setNote(e.target.value)} maxLength={140} placeholder="Add a line if you like (optional)" data-testid="nudge-reply-note"
            className="flex-1 text-sm px-3 py-1.5 rounded-full border border-stone-300 outline-none focus:border-amber-600 bg-white" />
          <button onClick={send} disabled={busy} data-testid="nudge-reply-send" className="amber-btn text-xs px-4 py-1.5">{busy ? "Sending…" : "Send"}</button>
        </div>
      )}
    </div>
  );
}

export function NudgeCard() {
  const [nudges, setNudges] = useState([]);
  useEffect(() => {
    api.get("/nudges").then((r) => setNudges(r.data)).catch(() => {});
  }, []);
  if (!nudges.length) return null;
  const dismiss = async (id, replied = false) => {
    if (!replied) await api.post(`/nudges/${id}/read`);
    setNudges((n) => n.filter((x) => x.id !== id));
  };
  return (
    <div className="space-y-3" data-testid="nudge-cards">
      {nudges.map((n) => (
        <div key={n.id} className="rounded-3xl p-5 bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200 flex items-start gap-3" data-testid={`nudge-${n.id}`}>
          <div className="w-10 h-10 rounded-2xl bg-amber-600 text-white flex items-center justify-center shrink-0"><HandHeart className="w-5 h-5" /></div>
          <div className="flex-1">
            <div className="text-[10px] font-bold uppercase tracking-widest text-amber-800">{n.from_role === "clinician" ? `${n.from_name} checked in` : `A note from ${n.from_name}`}</div>
            <p className="text-sm text-stone-800 mt-1 leading-relaxed" data-testid="nudge-message">{n.message}</p>
            <div className="text-xs text-stone-400 mt-1">{new Date(n.created_at).toLocaleDateString()}</div>
            {n.from_role === "clinician" && <ReplyRow nudge={n} onDone={() => dismiss(n.id, true)} />}
          </div>
          <button data-testid={`nudge-dismiss-${n.id}`} onClick={() => dismiss(n.id)} className="text-stone-400 hover:text-stone-700"><X className="w-4 h-4" /></button>
        </div>
      ))}
    </div>
  );
}
